import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import './TermsOfService.css';
import LanguageContext from '../../context/LanguageContext.js';

const TermsOfService = () => {
    const { dir } = useContext(LanguageContext);
    const { t } = useTranslation();

    return (
        <main className='main'>
            <Breadcrumb page={t('breadcrumb.termsOfService')} />

            <section className="section terms-of-service" dir={dir()}>
            <div className="container">
                <h1 className="section-title">{t('termsOfService.title')}</h1>
                <p className="terms-of-service-last-updated">{t('termsOfService.lastUpdated')}</p>
                
                <div className="terms-of-service-content">
                    <h2>{t('termsOfService.introduction')}</h2>
                    
                    <h3>{t('termsOfService.acceptanceOfTerms')}</h3>
                    <p>{t('termsOfService.acceptanceDescription')}</p>
                    
                    <h3>{t('termsOfService.useOfService')}</h3>
                    <p>{t('termsOfService.useDescription')}</p>
                    
                    <h3>{t('termsOfService.userAccounts')}</h3>
                    <p>{t('termsOfService.accountsDescription')}</p>
                    
                    <h3>{t('termsOfService.ordersAndPayments')}</h3>
                    <p>{t('termsOfService.ordersDescription')}</p>
                    
                    <h3>{t('termsOfService.deliveryAndPickup')}</h3>
                    <p>{t('termsOfService.deliveryDescription')}</p>
                    
                    <h3>{t('termsOfService.cancellationsAndRefunds')}</h3>
                    <p>{t('termsOfService.cancellationsDescription')}</p>
                    
                    <h3>{t('termsOfService.intellectualProperty')}</h3>
                    <p>{t('termsOfService.ipDescription')}</p>
                    
                    <h3>{t('termsOfService.userContent')}</h3>
                    <p>{t('termsOfService.userContentDescription')}</p>
                    
                    <h3>{t('termsOfService.disclaimers')}</h3>
                    <p>{t('termsOfService.disclaimersDescription')}</p>
                    
                    <h3>{t('termsOfService.limitationOfLiability')}</h3>
                    <p>{t('termsOfService.liabilityDescription')}</p>
                    
                    <h3>{t('termsOfService.indemnification')}</h3>
                    <p>{t('termsOfService.indemnificationDescription')}</p>
                    
                    <h3>{t('termsOfService.governingLaw')}</h3>
                    <p>{t('termsOfService.governingLawDescription')}</p>
                    
                    <h3>{t('termsOfService.changesToTerms')}</h3>
                    <p>{t('termsOfService.changesDescription')}</p>
                    
                    <h3>{t('termsOfService.severability')}</h3>
                    <p>{t('termsOfService.severabilityDescription')}</p>
                    
                    <h3>{t('termsOfService.entireAgreement')}</h3>
                    <p>{t('termsOfService.entireAgreementDescription')}</p>
                    
                    <h3>{t('termsOfService.contactUs')}</h3>
                    <p>{t('termsOfService.contactDescription')}</p>
                </div>
            </div>
        </section>
        </main>
    );
};

export default TermsOfService;